import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { useDataSourcesContext } from 'automation-ui-formula-editor/data-sources/DataSourcesContext';
import DataPassingPanelBodyActionOutput from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelBodyActionOutput';
import { actionOutputsFilterAndSort } from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/utils/actionOutputsFilterAndSort';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataPassingPanelBodyActionOutputs = ({
  actionId,
  dataSource,
  disabled,
  dataSourceAllowList,
  propertyFieldTypeAllowList,
  propertyTypeAllowList,
  requiredPermissionLevel,
  flowId,
  onDataPropertySelected,
  searchFilterString
}) => {
  const {
    getActionHeaderTitle
  } = useDataSourcesContext();
  const {
    dataSourceDefinition = {}
  } = dataSource || {};
  const {
    children = []
  } = dataSourceDefinition;
  const actionOutputsToDisplay = actionOutputsFilterAndSort({
    childrenDataSources: children,
    currentActionId: actionId,
    getActionHeaderTitle
  });
  if (actionOutputsToDisplay.length) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: actionOutputsToDisplay.map((child, index) => {
        const {
          toDataSource
        } = child;
        return /*#__PURE__*/_jsx(DataPassingPanelBodyActionOutput, {
          defaultOpen: !index,
          disabled: disabled,
          dataSourceAllowList: dataSourceAllowList,
          propertyFieldTypeAllowList: propertyFieldTypeAllowList,
          propertyTypeAllowList: propertyTypeAllowList,
          requiredPermissionLevel: requiredPermissionLevel,
          flowId: flowId,
          onDataPropertySelected: onDataPropertySelected,
          prefix: toDataSource,
          searchFilterString: searchFilterString
        }, toDataSource);
      })
    });
  }

  // return an empty state
  return /*#__PURE__*/_jsxs("div", {
    className: "p-left-9",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-formula-editor.data-passing-panel.ux-revised-mode.no-action-outputs.title"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.ux-revised-mode.no-action-outputs.description"
      })
    })]
  });
};
export default DataPassingPanelBodyActionOutputs;